import React, { useContext } from 'react'
import './CartItems.css'
import { ShopContext } from '../../Context/ShopContext'
import remove_icon from '../Assets/cart_cross_icon.png'

const CartItems = () => {

    const {
        getTotalCartAmount,
        all_product,
        cartItems,
        removeFromCart
    } = useContext(ShopContext)

    const handleProceedToCheckout = () => {

        // Find all products that are currently in the cart
        const cartProducts = all_product.filter(
            (product) => cartItems[product.id] > 0
        )

        // Don't continue if cart is empty
        if (cartProducts.length === 0) {
            alert('Your cart is empty.')
            return
        }

        // Create the WhatsApp message
        let message = `Hey, I want to purchase these products.\n\n`

        cartProducts.forEach((product, index) => {

            const quantity = cartItems[product.id]
            const itemTotal = product.new_price * quantity

            message += `${index + 1}. ${product.name}\n`
            message += `Price: ₹${product.new_price}\n`
            message += `Quantity: ${quantity}\n`
            message += `Item Total: ₹${itemTotal}\n\n`
        })

        // Add final total
        message += `--------------------------\n`
        message += `TOTAL: ₹${getTotalCartAmount()}\n`
        message += `--------------------------\n\n`
        message += `I would like to purchase these products. Please assist me with the order.`

        // Your WhatsApp number
        const whatsappUrl =
            `https://wa.me/918017166452?text=${encodeURIComponent(message)}`

        // Open WhatsApp
        window.open(whatsappUrl, '_blank')
        localStorage.removeItem('badtameezdil-cart')
localStorage.removeItem('badtameezdil-cart-time')

window.location.reload()
    }

    return (
        <div className='cartitems'>

            <div className="cartitems-format-main">
                <p>Products</p>
                <p>Title</p>
                <p>Price</p>
                <p>Quantity</p>
                <p>Total</p>
                <p>Remove</p>
            </div>

            <hr />

            
        {all_product.map((e) => {

         if (cartItems[e.id] > 0) {

        const imageUrl = e.image;
        return (


                        <div key={e.id}>

                            <div className="cartitems-format cartitems-format-main">

                                <img
                                    src={imageUrl}
                                    alt=""
                                    className='carticon-product-icon'
                                />

                                <p>{e.name}</p>

                                <p>₹{e.new_price}</p>

                                <button className='cartitems-quantity'>
                                    {cartItems[e.id]}
                                </button>

                                <p>
                                    ₹{e.new_price * cartItems[e.id]}
                                </p>

                                <img
                                    className='cartitems-remove-icon'
                                    src={remove_icon}
                                    onClick={() => {
                                        removeFromCart(e.id)
                                    }}
                                    alt=""
                                />

                            </div>

                            <hr />

                        </div>
                    )
                }

                return null
            })}

            <div className="cartitems-down">

                <div className="cartitems-total">

                    <h1>Cart Totals</h1>

                    <div>

                        <div className="cartitems-total-item">
                            <p>Subtotal</p>
                            <p>₹{getTotalCartAmount()}</p>
                        </div>

                        <hr />

                        <div className="cartitems-total-item">
                            <p>Shipping Fee</p>
                            <p>Free</p>
                        </div>

                        <hr />

                        <div className="cartitems-total-item">
                            <h3>Total</h3>
                            <h3>₹{getTotalCartAmount()}</h3>
                        </div>

                    </div>

                    <button onClick={handleProceedToCheckout}>
                        PROCEED TO CHECKOUT
                    </button>

                </div>

                <div className="cartitems-promocode">

                    <p>If you have a promo code, Enter it here</p>

                    <div className="cartitems-promobox">

                        <input
                            type="text"
                            placeholder='promo code'
                        />

                        <button>
                            Submit
                        </button>

                    </div>

                </div>

            </div>

        </div>
    )
}

export default CartItems